import axios from "axios";
import env from "../variables/config";

axios.defaults.baseURL = env.apiUrl;

const config = () => ({
  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

export interface EnrichmentRuleWithStats {
  _id: string;
  type: string;
  targetModel: "Event" | "Person";
  requiredFields: string[];
  missingFields: string[];
  handlerName: string;
  cronInterval: string;
  priority: number;
  enabled: boolean;
  description?: string;
  pendingCount: number;
  lastRunAt: string | null;
  processedLast24h: number;
  nextEventDetectedAt?: string | null;
}

export interface ExtraStat {
  count: number;
  lastDoneAt: string | null;
  processedLast24h: number;
  nextEventDetectedAt?: string | null;
}

export interface BodaccHistoryStat extends ExtraStat {
  checkedToday: number;
  totalWithSiren: number;
}

export interface ServicesStatsExtras {
  eventsWithNoPeople: ExtraStat;
  aiConfidencePending: ExtraStat;
  closingChecker: ExtraStat;
  linkedinScoringPending: ExtraStat;
  franchiseDetector: ExtraStat;
  backfillCategories: ExtraStat;
  emailScoringPending: ExtraStat;
  syncCityStats: ExtraStat;
  bodaccHistory: BodaccHistoryStat;
}

export interface ServicesStats {
  rules: EnrichmentRuleWithStats[];
  extras: ServicesStatsExtras;
}

export const getServicesStats = async (): Promise<ServicesStats> => {
  const res = await axios.get("/admin/enrichment-rules/services-stats", config());
  return res.data.data;
};

export const toggleEnrichmentRule = async (id: string, enabled: boolean): Promise<EnrichmentRuleWithStats> => {
  const res = await axios.put(`/admin/enrichment-rules/${id}`, { enabled }, config());
  return res.data.data;
};

export const runRule = async (id: string): Promise<void> => {
  await axios.post(`/admin/enrichment-rules/${id}/run`, {}, config());
};

export const runSystemService = async (key: string): Promise<void> => {
  await axios.post(`/admin/enrichment-rules/run-system/${key}`, {}, config());
};

export interface BodaccDetailStats {
  totalWithSiren: number;
  checkedToday: number;
  remaining: number;
  totalWithBodacc: number;
  lastCheckedAt: string | null;
  processedLast24h: number;
  recentlyChecked: Array<{
    _id: string;
    name: string;
    siren: string | null;
    city: string | null;
    bodaccCheckedAt: string;
    bodaccCount: number;
  }>;
}

export const getBodaccDetailStats = async (): Promise<BodaccDetailStats> => {
  const res = await axios.get("/admin/enrichment-rules/bodacc-stats", config());
  return res.data;
};
